import { injectable } from 'tsyringe'
import { MasterApiRepository } from '@/app/repositories/api/MasterApiRepository'
import { Master } from '@/domain/entities/Master'

@injectable()
export class MasterPresenter {
  private repository: MasterApiRepository

  constructor(repository: MasterApiRepository) {
    this.repository = repository
  }

  public loadMaster(params: Object, type: string): Promise<Master> {
    return this.repository.getAll(params, type)
  }

  public loadMasterspesial(params: Object, type: string): Promise<Master> {
    return this.repository.getAllSpesial(params, type)
  }
}
